<template>
  <div>
    <app-login-navigation />
    <app-form-reset class="mt-9" />
  </div>
</template>

<script>
export default {
  name: 'ResetPassword'
}
</script>
